import { useSelector } from 'react-redux'

export default function useIsUserAuthenticated() {
  const userSession = useSelector(({ auth: { userSession } }) => userSession)
  return userSession ? true : false
}
